<div class="language_card">
  <div class="language_card__option">
    {{ input_option() }}
  </div>
  <div class="language_card__icon">></div>
</div>
